import { Card, Checkbox, FormControlLabel, IconButton, Radio, RadioGroup } from '@mui/material';
import React from 'react';
import InfoIcon from '@mui/icons-material/Info';
import styles from "./styles.module.css"
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { IOStatusBadge } from '../../../components/IOStatusBadge/IOStatusBadge';
import { useLanguageLocale } from '../../../hooks/language-locale-hooks';

interface Props {
    closeDrawer: (state: boolean) => void;
}

const DryContactIOSettingTLUATPlus: React.FC<Props> = ({ closeDrawer }) => {

    const { t } = useLanguageLocale();

    const handleCloseClick = () => {
        closeDrawer(false);
    };

    return (
        <>
            <Card className={styles.card} data-testid="dry-contact-io-settings">
                <div className={styles.block} >
                    <div className={styles.title}>
                        <h2 className={styles.title}>G-North</h2>
                        <IconButton
                            aria-label="close"
                            onClick={handleCloseClick}
                            sx={{
                                color: (theme) => theme.palette.grey[500],
                            }}>
                            <CloseOutlinedIcon />
                        </IconButton>
                    </div>
                    <p style={{ padding: 0, margin: 0, color: '#424E54' }}>{t('DRY_CONTACT.DRY_CONTACT_SETTINGS_READ_ONLY')}</p>
                    <p style={{
                        fontSize: '12px',
                        display: 'flex',
                        columnGap: '5px',
                        alignItems: 'flex-start'
                    }}>
                        <InfoIcon style={{ color: "#0088F2", fontSize: "14px" }} />
                        <span style={{ lineHeight: '1.3' }}>{t('ATPLUS.DRY_CONTACT_SETTINGS_DESCRIPTION')}</span>
                    </p>
                    <div className={styles.detailBlock}>
                        <h3 style={{ fontSize: 16, margin: 0, padding: 0, color: '#424E54', fontWeight: 600 }}>{t('ATPLUS.ATPLUS_DRYCONTACT_STATUS')}</h3>
                        <div style={{ marginTop: 20 }}>
                            <div className={styles.row}>
                                <div style={{ borderBottom: '1px solid #8080805e', padding: '20px 10px', margin: '0px -10px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <h3 style={{ fontSize: '16px', margin: 0, padding: 0, color: '#424E54', fontWeight: 600 }}>{t('ATPLUS.ATPLUS_DRYCONTACT_STATUS_INPUT')}</h3>
                                    <IOStatusBadge status={'0'} />
                                </div>
                            </div>
                            <div className={styles.row}>
                                <div style={{ borderBottom: '1px solid #8080805e', padding: '20px 10px', margin: '0px -10px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <h3 style={{ fontSize: '16px', margin: 0, padding: 0, color: '#424E54', fontWeight: 600 }}>{t('ATPLUS.ATPLUS_DRYCONTACT_STATUS_OUTPUT')}</h3>
                                    <IOStatusBadge status={'0'} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.settingBlock} style={{
                        marginTop: '15px',
                        borderBottom: '1px solid #8080805e',
                        marginLeft: '-10px',
                        marginRight: '-10px',
                        padding: '0px 10px'
                    }}>
                        <h3 style={{ fontSize: '16px', margin: 0, padding: 0, color: '#424E54', fontWeight: 600 }}>{t('DRY_CONTACT.DEFAULT_SETTINGS')}</h3>
                        <h5 style={{ fontSize: '14px', margin: 0, padding: 0, marginTop: '15px', color: '#424E54', fontWeight: 600 }}>{t('DEVICE_DETAILS.ACTIVE')}</h5>
                        <RadioGroup name="controlled-radio-buttons-group" style={{ marginTop: '15px' }}>
                            <FormControlLabel style={{ fontSize: '14px', margin: 0, padding: 0, color: '#424E54', fontWeight: 400 }} value="open" control={<Radio />} label={t('DRY_CONTACT.NORMALLY_OPEN')} />
                            <FormControlLabel style={{ fontSize: '14px', margin: 0, padding: 0, color: '#424E54', fontWeight: 400 }} value="closed" control={<Radio />} label={t('DRY_CONTACT.NORMALLY_CLOSED')} />
                        </RadioGroup>
                    </div>
                    <div className={styles.contactOutputBlock} style={{
                        marginTop: '15px',
                        borderBottom: '1px solid #8080805e',
                        marginLeft: '-10px',
                        marginRight: '-10px',
                        padding: '0px 10px'
                    }}>
                        <h3 style={{ fontSize: '16px', margin: 0, padding: 0, color: '#424E54', fontWeight: 600 }}>{t('DRY_CONTACT.DRY_CONTACT_OUTPUT')}</h3>
                        <h5 style={{ fontSize: '14px', margin: 0, padding: 0, marginTop: '15px', color: '#424E54', fontWeight: 600 }}>{t('DEVICE_DETAILS.ACTIVE')}</h5>
                        <div style={{ marginTop: '15px' }}>
                            <Checkbox color="default" /> {t('DRY_CONTACT.NORMALLY_OPEN')}
                        </div>
                    </div>
                    <div className={styles.settingBlock} style={{ marginTop: '15px' }}>
                        <h3 style={{ fontSize: '16px', margin: 0, padding: 0, color: '#424E54', fontWeight: 600 }}>{t('DRY_CONTACT.DEFAULT_SETTINGS')}</h3>
                        <h5 style={{ fontSize: '14px', margin: 0, padding: 0, marginTop: '15px', color: '#424E54', fontWeight: 600 }}>{t('DRY_CONTACT.DRY_CONTACT_INPUT')}</h5>
                        <div style={{ marginTop: '15px' }}>
                            <Checkbox color="default" /> {t('DRY_CONTACT.NORMALLY_OPEN')}
                        </div>
                        <div>
                            <Checkbox color="default" /> {t('DRY_CONTACT.NORMALLY_CLOSED')}
                        </div>
                    </div>
                </div>
            </Card>
        </>
    );
};

export default DryContactIOSettingTLUATPlus;